// UI copy shared by the portal and public surveys. Customer content is never translated.
export const portalIT = {
  question_option_label: 'Opzione {{option}} della domanda {{question}}',
  surveys: 'Questionari',
  survey: 'Questionario',
  listen_to_your_customers_and_assign_tags_after_submission:
    'Ascolta i tuoi clienti e assegna i tag dopo la compilazione.',
  select_a_venue_to_manage_surveys:
    'Seleziona un locale per gestire i questionari.',
  create_survey: 'Crea questionario',
  edit_survey: 'Modifica questionario',
  search_surveys_by_name: 'Cerca questionario per nome',
  search_for_a_survey_by_name: 'Cerca un questionario per nome…',
  no_surveys_found: 'Nessun questionario trovato',
  create_your_first_survey_to_collect_feedback_and_ratings:
    'Crea il primo questionario per raccogliere opinioni e valutazioni.',
  published: 'Pubblicato',
  paused_draft: 'In pausa / bozza',
  responses: 'Risposte',
  rating: 'Valutazione',
  none_yet: 'Ancora nessuna',
  customer_link: 'Link cliente',
  surveys_2: 'questionari',
  questions: 'domande ·',
  tags: 'tag',
  responses_2: 'risposte',
  survey_saved: 'Questionario salvato',
  save_survey: 'Salva questionario',
  write_your_questions_a_five_star_rating_is_always_included_at_the_end:
    'Scrivi le domande. La valutazione a 5 stelle è sempre presente in fondo.',
  survey_name: 'Nome del questionario *',
  e_g_how_was_your_dinner: 'Es. Com’è andata la tua cena?',
  introduction_for_the_customer: 'Introduzione per il cliente',
  tags_to_add_after_submission: 'Tag da aggiungere dopo l’invio',
  these_are_added_to_the_customer_s_tags_without_removing_existing_ones:
    'Si aggiungono ai tag del cliente, senza eliminare quelli esistenti.',
  loading_tags: 'Caricamento tag…',
  select_venue_tags: 'Seleziona i tag del locale',
  question_and_answer_tags_are_not_yet_supported_by_the_connected_service_you_can_confi:
    'I tag delle domande e delle singole risposte non sono ancora disponibili sul servizio collegato. Puoi configurarli qui, ma potrai salvarli dopo l’aggiornamento del servizio.',
  question_and_answer_tags_require_an_update_to_the_connected_service_the_survey_was_no:
    'I tag delle domande e delle risposte richiedono l’aggiornamento del servizio collegato. Il questionario non è stato salvato.',
  enter_a_name_question_text_and_at_least_two_distinct_options_for_choice_questions:
    'Inserisci il nome, il testo delle domande e almeno due opzioni diverse per le domande a scelta.',
  question: 'Domanda',
  question_text: 'Testo della domanda *',
  answer_type: 'Tipo di risposta',
  text_answer: 'Risposta aperta',
  single_choice_one_answer: 'Scelta singola — una risposta',
  multiple_choice_several_answers: 'Scelta multipla — più risposte',
  question_tags: 'Tag della domanda',
  added_when_the_customer_answers_this_question:
    'Si aggiungono quando il cliente risponde a questa domanda.',
  no_tags_for_this_question: 'Nessun tag per questa domanda',
  answer_options_2_to_20: 'Opzioni di risposta (da 2 a 20)',
  tags_when_the_customer_selects_this_answer:
    'Tag se il cliente sceglie questa risposta',
  select_tags_for_this_answer: 'Seleziona i tag per questa risposta',
  add_option: 'Aggiungi opzione',
  remove_option: 'Rimuovi opzione',
  required_answer: 'Risposta obbligatoria',
  add_question: 'Aggiungi domanda',
  move_question_up: 'Sposta domanda in alto',
  move_question_down: 'Sposta domanda in basso',
  remove_question: 'Rimuovi domanda',
  final_rating_from_1_to_5_stars: 'Valutazione finale da 1 a 5 stelle',
  the_customer_selects_a_star_rating_before_submitting_the_survey:
    'Il cliente sceglierà le stelle prima di inviare il questionario.',
  publish_survey: 'Pubblica il questionario',
  when_disabled_links_no_longer_accept_responses_existing_responses_remain_saved:
    'Se disattivato, i link non accettano compilazioni. Le risposte già ricevute restano salvate.',
  survey_preview: 'Anteprima del questionario',
  create_a_customer_link: 'Crea il link per un cliente',
  search_customers_by_name_email_or_code:
    'Cerca il cliente per nome, email o codice',
  type_at_least_2_characters: 'Scrivi almeno 2 caratteri…',
  searching: 'Ricerca in corso…',
  no_customers_found: 'Nessun cliente trovato.',
  generate_customer_link: 'Genera link cliente',
  this_link_associates_the_response_with_the_selected_customer:
    'Questo link collega la risposta al cliente selezionato.',
  survey_link: 'Link del questionario',
  link_copied: 'Link copiato',
  copy_the_link_manually_from_the_field_above:
    'Copia manualmente il link dal campo qui sopra.',
  loading_responses: 'Caricamento risposte…',
  you_have_not_received_any_responses_yet: 'Non hai ancora ricevuto risposte.',
  tags_added: 'Tag aggiunti:',
  the_request_could_not_be_completed:
    'Non è stato possibile completare la richiesta.',
  your_opinion_matters: 'La tua opinione conta',
  the_link_is_incomplete_ask_the_venue_for_a_new_link:
    'Il link non è completo. Chiedi al locale un nuovo link.',
  this_survey_is_unavailable_ask_the_venue_for_a_new_link:
    'Questo questionario non è disponibile. Chiedi al locale un nuovo link.',
  we_could_not_load_the_survey_please_try_again:
    'Non riusciamo a caricare il questionario. Riprova.',
  loading_failed: 'Errore di caricamento.',
  the_survey_has_been_updated_please_review_the_questions:
    'Il questionario è stato aggiornato. Ricontrolla le domande.',
  check_your_answers_and_choose_a_rating_from_1_to_5_stars:
    'Controlla le risposte e scegli da 1 a 5 stelle.',
  submission_failed_please_try_again_shortly:
    'Invio non riuscito. Riprova tra poco.',
  submission_failed: 'Invio non riuscito.',
  your_voice_helps_us_grow: 'La tua voce, la nostra crescita',
  a_moment_to_listen: 'UN MOMENTO PER ASCOLTARTI',
  your_feedback_makes_a_difference: 'La tua opinione fa la differenza.',
  preparing_your_survey: 'Stiamo preparando il tuo questionario…',
  responses_sent: 'RISPOSTE INVIATE',
  thank_you_for_your_feedback: 'Grazie per la tua opinione!',
  your_answers_have_been_recorded_thank_you_for_taking_the_time_to_help_us_improve:
    'Le tue risposte sono state registrate. Grazie per averci dedicato un momento: ci aiuteranno a migliorare.',
  tell_us_about_your_experience: 'Raccontaci la tua esperienza',
  answer_the_questions_and_leave_your_final_rating:
    'Rispondi alle domande e lascia la tua valutazione finale.',
  your_answers_are_linked_to_your_customer_profile:
    'Le risposte vengono associate alla tua anagrafica cliente.',
  powered_by: 'Realizzato con',
  optional: ' (facoltativa)',
  write_your_answer_here: 'Scrivi qui la tua risposta…',
  choose_one_answer: 'Scegli una sola risposta.',
  you_can_choose_several_answers: 'Puoi scegliere più risposte.',
  how_would_you_rate_your_experience: 'Come valuti la tua esperienza? *',
  choose_from_1_to_5_stars: 'Scegli da 1 a 5 stelle.',
  no_rating_selected: 'Nessuna valutazione selezionata',
  submit_your_feedback: 'Invia la tua opinione',
  text_answers_can_contain_up_to_5_000_characters:
    'La risposta aperta può contenere al massimo 5000 caratteri.',
  choose_a_valid_answer: 'Scegli una risposta valida.',
  choose_only_the_available_options: 'Scegli solo le opzioni disponibili.',
  choose_a_rating_from_1_to_5_stars: 'Scegli una valutazione da 1 a 5 stelle.',
  complete_the_question_value: 'Completa la domanda: {{question}}',
  value_out_of_5_stars: '{{count}} su 5 stelle',
  value_stars: '{{count}} stelle',
  value_questions_value_tags: '{{count}} domande · {{tags}} tag',
  value_responses: '{{count}} risposte',
  value_surveys: '{{count}} questionari',
  value_questions_rating: '{{count}} domande + stelle',
  responses_value: 'Risposte · {{name}}',
};
